import React, { useLayoutEffect, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useFavicon } from '../../hooks/useFavicon';
import { issuerSelector } from '../../selectors';
import { LoadingOverlay } from '../../components/abc/loading-overlay/loading-overlay';
import { ASSETS_CDN_URL } from '../../utils/constants';

export function NotFoundPage() {
  const history = useHistory();
  const [shouldShowLoading, setShouldShowLoading] = useState(true);
  const { displayName } = useSelector(issuerSelector);

  useFavicon(`${ASSETS_CDN_URL}/favicon.ico`);

  useLayoutEffect(() => {
    document.title = shouldShowLoading
      ? 'Loading...'
      : 'Page Not Found  | ESPP.com';
    // Cleanup function: Set the document title back to what it was before:
    return () => {
      if (displayName) {
        document.title = displayName;
      } else {
        document.title = 'ESPP.com';
      }
    };
  }, [shouldShowLoading, displayName]);

  // Sometimes we are still loading a feature flag value on first page load or something,
  // which can make a page flash with a 404 if a flag is initially false but then it's
  // true when fetched from the server. So to avoid this, we make the 404 component render
  // the loading screen for 1 second before turning into the 404 page.
  useEffect(() => {
    setTimeout(() => setShouldShowLoading(false), 1000);
  }, []);

  if (shouldShowLoading) {
    return <LoadingOverlay />;
  }

  return (
    <div
      style={{
        minHeight: '70vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <h1
        className="title-1"
        style={{
          fontSize: '150px',
          fontWeight: 'bold',
          lineHeight: '110%',
        }}
      >
        404
      </h1>
      <h2
        style={{
          fontSize: '28px',
        }}
      >
        Not found
      </h2>
      <p>
        The page you are looking for does not exist or another error occured.
      </p>
      <br />
      <button
        type="button"
        className="btn"
        style={{ minWidth: '200px' }}
        onClick={() => {
          history.goBack();
        }}
      >
        Go back
      </button>
    </div>
  );
}
